import z from "zod";

export const clientContactModalDataSchema = z.object({});

export type ClientContactModalDataProps = z.infer<
  typeof clientContactModalDataSchema
>;
